import { render, staticRenderFns } from "./AdminHeader.vue?vue&type=template&id=7c63656e&scoped=true&"
import script from "./AdminHeader.vue?vue&type=script&lang=js&"
export * from "./AdminHeader.vue?vue&type=script&lang=js&"
import style0 from "./AdminHeader.vue?vue&type=style&index=0&id=7c63656e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c63656e",
  null
  
)

export default component.exports